import { useEffect } from "react";

// When + in the top bar sends the user to this page to add something, open the page's editor once.
// `requested` is true until `onHandled` clears it in NudgeApp; `open` opens the page's "new" editor.
export function useAddRequest(requested, onHandled, open) {
  useEffect(() => {
    if (!requested) return;
    open();
    onHandled?.();
  }, [requested]); // eslint-disable-line react-hooks/exhaustive-deps
}
